import ruby from './ruby';
import python from './python';
import java from './java';
import php from './php';
import node from './node';
import go from './go';
import dotnet from './dotnet';

const instructions = {
  ruby: {
    build: 'bundle install',
    run: 'ruby server.rb -o 0.0.0.0',
    entry: 'localhost:4242',
  },
  python: {
    build: 'pip3 install -r requirements.txt',
    run: 'export FLASK_APP=server.py\npython3 -m flask run --port=4242',
    entry: 'localhost:4242',
  },
  php: {
    build: 'composer install',
    run: 'php -S 127.0.0.1:4242 -docroot=public',
    entry: 'localhost:4242/public',
  },
  java: {
    build: 'mvn package',
    run:
      'java -cp target/stripe-terminal-1.0.0-SNAPSHOT-jar-with-dependencies.jar com.stripe.sample.Server',
    entry: 'localhost:4242',
  },
  node: {
    build: 'npm install',
    run: 'npm start',
    entry: 'localhost:4242',
  },
  go: {
    build: '',
    run: 'go run server.go',
    entry: 'localhost:4242',
  },
  dotnet: {
    build: 'dotnet restore',
    run: 'dotnet run',
    entry: 'localhost:4242',
  },
  javascript: {
    build: '',
    run: '',
  },
  esnext: {
    build: '',
    run: '',
  },
  swift: {},
  objc: {},
  kotlin: {},
  javaclient: {},
};

const buildFiles = {
  php: {
    files: [{name: 'composer.json', raw: php.build}],
  },
  java: {
    files: [{name: 'pom.xml', raw: java}],
  },
  node: {
    files: [{name: 'package.json', raw: node.build}],
  },
  ruby: {
    files: [{name: 'Gemfile', raw: ruby.build}],
  },
  python: {
    files: [{name: 'requirements.txt', raw: python}],
  },
  go: {
    files: [{name: 'go.mod', raw: go.build}],
  },
  dotnet: {
    files: [{name: 'StripeExample.csproj', raw: dotnet.build}],
  },
  swift: {},
  objc: {},
  kotlin: {},
  javaclient: {},
};

const generateFiles = (client, server) => {
  return buildFiles[server];
};

const readme = (client, server) => {
  let doc = `# Accept in-person payments\n\nSet up the Stripe Terminal SDK so you can begin accepting in-person payments. Included are some basic build and run scripts you can use to start up the application.\n\n## Running the sample\n\n`;
  const serverInstructions = instructions[server];
  const clientInstructions = instructions[client];

  let step = 1;
  if (serverInstructions.build) {
    doc += `${step}. Build the server\n\n\`\`\`\n${serverInstructions.build}\n\`\`\`\n\n`;
    step++;
  }
  if (serverInstructions.run) {
    doc += `${step}. Run the server\n\n\`\`\`\n${serverInstructions.run}\n\`\`\`\n\n`;
    step++;
  }
  if (clientInstructions.build) {
    doc += `${step}. Build the client app\n\n\`\`\`\n${clientInstructions.build}\n\`\`\`\n\n`;
    step++;
  }
  if (clientInstructions.run) {
    doc += `${step}. Run the client app\n\n\`\`\`\n${clientInstructions.run}\n\`\`\`\n\n`;
    step++;
  }
  doc += `${step}. Go to [http://${clientInstructions.entry ||
    serverInstructions.entry}](http://${clientInstructions.entry ||
    serverInstructions.entry})\n`;

  return doc;
};

export default {
  readme,
  buildInstructions: generateFiles,
};
